import { RootProvider as UiKitRootProvider } from '@revolut-internal/ui-kit'
import { FC, PropsWithChildren } from 'react'

import type { LayoutContextValue } from '../LayoutProvider/LayoutProvider'
import { useTopNav } from './hooks'

type Props = PropsWithChildren<{ mode: LayoutContextValue['themeMode'] }>

export const RootProvider: FC<Props> = ({ children, mode }) => {
  const topNav = useTopNav()

  return (
    <UiKitRootProvider topNav={topNav} mode={mode}>
      {children}
    </UiKitRootProvider>
  )
}
